import React from 'react'

export default class RFILightbox extends React.Component {
    componentDidMount() {
        window.addEventListener('keydown', (e) => {
            if( e.key === 'Escape' ) {
                this.props.handleClose()
            }
        })
    }
    render() {
        return (
            <div className="lightbox">
                <div onClick={ ()=>{ this.props.handleClose() }} className="close"><span></span>
                <span></span></div>
                <div className="lightbox-container">
                    { this.props.children }
                </div>
                <div onClick={ ()=>{ this.props.handleClose() }} className="mask-to-close" />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/RFILightbox/index.js